import styled from '@emotion/styled';

const DatePickerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  .native-date-input {
    background: rgba(255, 255, 255, 0.9);
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-radius: 12px;
    padding: 12px 16px;
    font-size: 1rem;
    color: #333;
    transition: all 0.3s ease;
    min-width: 160px;
    margin-top: 10px;

    &:hover {
      border-color: rgba(255, 255, 255, 0.6);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }

    &:focus {
      outline: none;
      border-color: #fff;
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
    }

    &::-webkit-calendar-picker-indicator {
      cursor: pointer;
      opacity: 0.7;

      &:hover {
        opacity: 1;
      }
    }
  }
`;

const DatePicker = ({ value, onChange, id, placeholder = 'Seleccionar fecha', className = '' }) => {
  const handleDateChange = (e) => {
    if (onChange) {
      onChange(e.target.value);
    }
  };

  return (
    <DatePickerContainer className={className}>
      <input
        type="date"
        value={value || ''}
        onChange={handleDateChange}
        id={id}
        placeholder={placeholder}
        className="native-date-input"
      />
    </DatePickerContainer>
  );
};

export default DatePicker;
